module.exports = __webpack_public_path__ + "static/media/tray7.78089a73.png";